import config from '../../config';
import {normalizeISOStringToDateOfBirth} from '../../utils/date';
import {logger} from '../../utils/logger';
import {UserInfoV2Response, UserV2} from '../types/user.type';

export const transformUserV2 = (data: UserInfoV2Response): UserV2 => {
  const mflIdKey = `MFL_ID_${String(config.BASE_TENANT)}` as keyof UserInfoV2Response;
  const mflID = data[mflIdKey] as string;

  if (!mflID) {
    logger.error('UserTransformer', 'MFL ID not found', {data});
  }

  // Backend may send YYYY-MM-DD or ISO datetime string - normalize to YYYY-MM-DD
  const dateOfBirth = normalizeISOStringToDateOfBirth(data.Date_of_Birth);

  return {
    id: mflID || '',
    firstName: data.First_Name,
    lastName: data.Last_Name,
    email: data.Email,
    dateOfBirth: dateOfBirth,
    phoneNumber: data.Mobile,
    billingAddress: {
      // DIS-1592: Zoho stores a single comma-joined string. `''.split(',')` is
      // `['']` — length 1, so it passes every emptiness check in the app and a
      // fake one-empty-string address reaches checkout. Trim and drop empties so
      // an absent, empty, or whitespace-only street all yield no lines.
      lines:
        data.Mailing_Street?.split(',')
          .map(line => line.trim())
          .filter(Boolean) || [],
      postal_code: data.Mailing_Zip || '',
      locality: data.Mailing_City || '',
      administrative_area: data.Mailing_State || '',
    },
    zohoId: data.id,
  };
};
